import type MP4Box from 'mp4box';
import { TrackEventProp } from '@studio/constants/tracking-constants';
import { KB } from '../../constants';
import type { AddError, VideoUploadTrackEventProperties } from '../../types/upload-video';
import { VALIDATIONS } from '../../types/upload-video';

const BITRATE_LIMITS = {
  lowFramerate: 8,
  highFramerate: 12,
  lowFramerate4k: 32,
  highFramerate4k: 48,
  lowFramerate32x9: 16,
  highFramerate32x9: 22,
} as const;

const validateMaxVideoBitrate = (
  info: MP4Box.Mp4BoxInfo,
  addError: AddError,
  trackEventProperties: VideoUploadTrackEventProperties
): number => {
  if (!info.videoTracks.length) {
    return 0;
  }
  const [videoTrack] = info.videoTracks;
  const { bitrate, nb_samples: nbSamples, samples_duration: samplesDuration, timescale } = videoTrack;

  const bitrateMbps = bitrate / KB / KB;
  const fps = timescale / (samplesDuration / nbSamples);

  const wideAspectRatio = 32 / 9;
  const isWide = videoTrack.video.width / videoTrack.video.height === wideAspectRatio;

  console.log(`Video bitrate: ${bitrateMbps.toFixed(3)} Mbps (${fps} fps)`);

  trackEventProperties[TrackEventProp.VIDEO_UPLOAD_VIDEO_BITRATE_MBPS] = bitrateMbps;

  const upTo4kBitrate = videoTrack.track_height > 1_080;
  const finalBitrate = bitrate / 1_000;

  if (isWide) {
    const highFps = fps === 59.94 || fps === 60;
    if (highFps && bitrateMbps > BITRATE_LIMITS.highFramerate32x9) {
      addError(VALIDATIONS.MAX_VIDEO_BITRATE_WIDE);
      return 0;
    } else if (!highFps && bitrateMbps > BITRATE_LIMITS.lowFramerate32x9) {
      addError(VALIDATIONS.MAX_VIDEO_BITRATE_WIDE);
      return 0;
    }
    return finalBitrate;
  }

  if (
    !upTo4kBitrate &&
    ((fps <= 30 && bitrateMbps > BITRATE_LIMITS.lowFramerate) || bitrateMbps > BITRATE_LIMITS.highFramerate)
  ) {
    addError(VALIDATIONS.MAX_VIDEO_BITRATE);
    return 0;
  }

  if ((fps <= 30 && bitrateMbps > BITRATE_LIMITS.lowFramerate4k) || bitrateMbps > BITRATE_LIMITS.highFramerate4k) {
    addError(VALIDATIONS.MAX_VIDEO_BITRATE_4K);
    return 0;
  }

  return finalBitrate;
};

export default validateMaxVideoBitrate;
